import React, { ComponentProps } from 'react';
import { clsx } from 'clsx';

export type OpenNetOpsTicketLayoutProps = ComponentProps<'div'>;

export const OpenNetOpsTicketLayout = ({
  className,
  children,
  ...props
}: OpenNetOpsTicketLayoutProps) => {
  return (
    <div
      className={clsx(
        'grid grid-cols-1 items-start gap-8 xl:grid-cols-[2fr_minmax(0,_508px)]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
